import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (e.g., #section), scroll to that element
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        // Scroll to the element with offset for fixed header
        setTimeout(() => {
          window.scrollTo({
            top: element.offsetTop - 80,
            behavior: 'smooth'
          });
        }, 100);
      }
      return;
    }
    
    // Otherwise, scroll to top instantly on route change
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;

